import { render, staticRenderFns } from "./makeOrder.vue?vue&type=template&id=a743245c&scoped=true&"
import script from "./makeOrder.vue?vue&type=script&lang=js&"
export * from "./makeOrder.vue?vue&type=script&lang=js&"
import style0 from "./makeOrder.vue?vue&type=style&index=0&id=a743245c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a743245c",
  null
  
)

export default component.exports